type CurrencyLocale = 'pt-BR' | 'en-US';

function padDecimals(price: string) {
	const splittedPrice = price.split(/[\s,.]+/);
	if (splittedPrice.length > 1) {
		splittedPrice[splittedPrice.length - 1] = splittedPrice[splittedPrice.length - 1].padEnd(
			2,
			'0',
		);
	}
	return splittedPrice.join(',');
}
function padDecimalsToBills(price: string) {
	if (!price.includes('.')) {
		return price.padEnd(price.length + 2, '0');
	}
	const splittedPrice = price.split(/[\s,.]+/);
	if (splittedPrice.length > 1) {
		splittedPrice[splittedPrice.length - 1] = splittedPrice[splittedPrice.length - 1].padEnd(
			2,
			'0',
		);
	}
	return splittedPrice.join(',');
}

export function formatPriceIncomeTax(price: string | number = 0, locale: CurrencyLocale = 'pt-BR') {
	let newPrice = price;
	if (typeof newPrice === 'string' && !newPrice.includes('.')) {
		newPrice = newPrice.padEnd(newPrice.length + 2, '0');
	}
	const parsedPrice =
		typeof newPrice === 'string'
			? parseFloat(padDecimals(newPrice).replace(/\D/g, '')) / 100
			: newPrice;

	const formatter = new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: locale === 'pt-BR' ? 'BRL' : 'USD',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

	return formatter.format(parsedPrice);
}

export function parsePrice(price: string | number = 0) {
	return typeof price === 'string' ? parseFloat(padDecimals(price).replace(/\D/g, '')) / 100 : price;
}

export function formatPrice(price: string | number = 0, locale: CurrencyLocale = 'pt-BR') {
	const parsedPrice = parsePrice(price);

	const formatter = new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: locale === 'pt-BR' ? 'BRL' : 'USD',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

	return formatter.format(parsedPrice);
}
export function formatPriceBill(price: string | number = 0, locale: CurrencyLocale = 'pt-BR') {
	const parsedPrice =
		typeof price === 'string'
			? parseFloat(padDecimalsToBills(price).replace(/\D/g, '')) / 100
			: price;

	const formatter = new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: locale === 'pt-BR' ? 'BRL' : 'USD',
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});

	return formatter.format(parsedPrice);
}

export function formatPriceRefund(price: string) {
	const priceFormatted = parseFloat(price.replace(',', '.'));

	return new Intl.NumberFormat('pt-Br', {
		style: 'currency',
		currency: 'BRL',
	}).format(priceFormatted);
}

export const formatCurrency = (value: string): string => {
	const cleanedValue = value.replace(/\D/g, '');

	if (!cleanedValue || parseInt(cleanedValue, 10) === 0) {
		return '0,00';
	}

	let formattedValue = new Intl.NumberFormat('pt-BR', {
		style: 'decimal',
		maximumFractionDigits: 2,
		minimumFractionDigits: 2,
	}).format(parseFloat(cleanedValue) / 100);

	formattedValue = formattedValue.replace(/\./g, '');

	return formattedValue;
};
